import MoreStepForm from './Powermail/MoreStepForm';

function powermailFormAjaxSubmit($form) {
  var id = '#' + $form.attr('id');
  var action = $form.attr('action');

  $form.on('submit', function(e) {
    $form
      .closest('.tx-powermail')
      .prepend(
        '<div class="loading-spinner-outer"><div class="loading-spinner"></div></div>'
      );

    e.preventDefault();

    var formData = new FormData(this);

    $.ajax({
      url: action,
      type: 'POST',
      data: formData,
      success: function(data) {
        var $content = $(data)
          .find(id)
          .closest('.tx-powermail');
        if ($content.length) {
          jQuery(document)
            .find(id)
            .closest('.tx-powermail')
            .html($content.html());

          // Reload our JS
          initialize();

          $(window).scrollTop($(id).offset().top - 100);
        }
      },
      cache: false,
      contentType: false,
      processData: false,
    });
  });
}

function loadPowermailComponent($component) {
  var pageId = $component.data('page');
  if (!pageId) {
    return null;
  }

  // SYNFLEX-152: der frühere baseUrl-Ausdruck war durch Operator-Präzedenz immer '',
  // die Anfrage lief also ohnehin relativ zur aktuellen URL. Genau das ist richtig:
  // TYPO3 leitet die Sprache aus dem Pfad ab, /it/?id=2509 liefert das Formular auf Italienisch.
  $component.load(
    '?id=' + pageId + ' #content section .section-list ',
    function() {
      powermailFormAjaxSubmit($component.find('form.powermail_form'));
    }
  );
}

function multistep() {
  $('.tab').click(function() {
    $('.tab').removeClass('active');
    $(this).addClass('active');
  });

  $('.morestep-arrow').click(function() {
    var step = $(this).data('powermail-morestep-show');
    $('.tab').removeClass('active');
    $('.tab[data-powermail-morestep-show="' + step + '"]').addClass('active');
  });
}

function initialize() {
  var $document = jQuery(document);
  var $forms = $document.find('form.powermail_form');
  var $formComponents = $document.find('.form-component');

  $forms.each(function() {
    powermailFormAjaxSubmit($(this));
  });

  $formComponents.each(function() {
    loadPowermailComponent($(this));
  });

  let moreStepForm = new MoreStepForm();
  moreStepForm.initialize();

  multistep();
}

jQuery(document).on('ready', function() {
  initialize();
});
